(() => {
  const translations = new Map(JSON.parse(document.getElementById('dh-es-translations').textContent));
  const translate = value => {
    const trimmed = value.trim();
    let result = translations.get(trimmed);
    if (!result && /^€\d+[.,]\d{2} \/ pair$/.test(trimmed)) result = trimmed.replace(/^€(\d+)[.,](\d{2}) \/ pair$/, '$1,$2 € / par');
    if (!result && /^ADD TO CART\s*·/.test(trimmed)) result = trimmed.replace(/^ADD TO CART/, 'AÑADIR AL CARRITO');
    if (!result && /^(Agregar|Añadir) al carrito\s*·/.test(trimmed)) result = trimmed.replace(/^(Agregar|Añadir) al carrito/, 'AÑADIR AL CARRITO');
    if (!result && /^(Price|Original price):/.test(trimmed)) result = trimmed.replace(/^Original price:/,'Precio anterior:').replace(/^Price:/,'Precio:');
    if (!result && /^(Size|Colour):$/.test(trimmed)) result = trimmed.replace('Size:','Talla:').replace('Colour:','Color:');
    if (!result && trimmed.includes('Talón Firme Work Socks')) result = trimmed.replace('Talón Firme Work Socks','Calcetines de trabajo Talón Firme').replace(/\bWhite\b/g,'Blanco').replace(/\bBlack\b/g,'Negro');
    if (!result && /^Average rating is [\d.]+ stars$/.test(trimmed)) result = trimmed.replace(/^Average rating is ([\d.]+) stars$/, 'Valoración media: $1 estrellas').replace(/(\d)\.(\d)/, '$1,$2');
    if (!result && /^Doce Horas review image \d$/.test(trimmed)) result = trimmed.replace('Doce Horas review image', 'Foto de opinión Doce Horas');
    return result ? value.replace(trimmed, result) : value;
  };
  const scopes = '.kaching-bundles__block,.jdgm-widget,header,header-drawer,footer,cart-drawer,cart-notification,product-form,.dh-review-photo,.image-with-text,.dh-mechanism,.dh-features,#shopify-pc__banner,#shopify-pc__prefs';
  const localize = () => {
    document.querySelectorAll(scopes).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.parentElement?.closest('script,style,textarea,svg')) continue;
        const text = translate(node.nodeValue);
        if (text !== node.nodeValue) node.nodeValue = text;
      }
      root.querySelectorAll('[aria-label],[title],[alt]').forEach(node => {
        ['aria-label','title','alt'].forEach(attribute => {
          const value = node.getAttribute(attribute);
          if (value === null) return;
          const text = translate(value);
          if (text !== value) node.setAttribute(attribute,text);
        });
      });
    });
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled=false; localize();});
  });
  localize();
  observer.observe(document.body,{subtree:true,childList:true,characterData:true});
})();
